export default () => Math.floor(Math.random() * 100000).toString();
